module.exports = __webpack_public_path__ + "img/W-G15.c7c11ad8.jpg";